<template>
    <v-container
        id="about"
        class="py-8"
    >
        <homepage-title>Apa itu UKOM NAKES?</homepage-title>

        <v-row align="center">
            <v-col
                md="3"
                class="d-none d-md-flex"
            >
                <v-img
                    alt="Mediko logo"
                    src="@/assets/images/icon.png"
                    contain
                    max-height="128"
                ></v-img>
            </v-col>
            <v-col md="9">
                <p>
                    Ukomnakes adalah platform try out uji kompetensi tenaga
                    kesehatan. Kami memberikan yg terbaik untuk membantumu
                    meraih nilai uji kompetensi yang memuaskan. Soal-soal kami
                    disusun oleh tim yang berkualitas dan telah melewati cek
                    kualitas berulang kali!
                </p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import HomepageTitle from './HomepageTitle'

export default {
    components: {
        HomepageTitle,
    },
}
</script>
